export abstract class FillableModel {
    public fill(json: any) {
        for (let field in json) {
            if (this.hasOwnProperty(field)) {
                this[field] = json[field];
            }
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/models/fillable.model.ts